export default __webpack_public_path__ + "static/media/blog-img89.3f5361b8.jpg";